module.exports = __webpack_public_path__ + "img/andalucia-el-gran-escenario-de-la-alegria.bc931466.png";